// src/components/Header.jsx
import React from "react";
import { AppBar, Toolbar, Container } from "@mui/material";
import HeaderLogoBar from "./HeaderLogoBar";
import HeaderNavBar from "./HeaderNavBar";

function Header() {
  return (
    <AppBar
      position="sticky"
      //elevation={0} // removes shadow
      sx={{
        // boxShadow: "none", // ensure no shadow
        border: "none", // ensure no border
          //backgroundColor: "transparent", // optional: remove background
      }}
    >
      <Toolbar
        disableGutters // removes padding from toolbar
        sx={{
          width: "100%", border: "none",
          //  boxShadow: "none"
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            border: "none",
            // boxShadow: "none",
          }}
        >
          <HeaderLogoBar />
          <HeaderNavBar />
        </Container>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
